import { Typography } from '@mui/material';
import Modal from 'components/Modal';
import { referAndEarnNotification } from 'constants/availableNotifications';
import { pushAnalyticsEvent } from 'helpers/analytics';
import { StyledContent, Image, StyledButton } from './ReferAndEarn.styles';

interface ReferAndEarnProps {
  isOpen: boolean;
  onClose: () => void;
}

const { title, description, path, callToAction } = referAndEarnNotification;

const ReferAndEarn = ({ isOpen, onClose }: ReferAndEarnProps) => (
  <Modal open={isOpen} closeType="close" onClose={onClose} iconColor="dark">
    <StyledContent>
      <Typography variant="h2" gutterBottom>
        {title}
      </Typography>
      <Image />
      <Typography variant="body1" gutterBottom>
        {description}
      </Typography>
      <StyledButton
        fullWidth
        variant="contained"
        color="primary"
        onClick={() => pushAnalyticsEvent({ event: 'clickReferAFriend', title: 'Home Page' })}
        href={path}
      >
        {callToAction}
      </StyledButton>
    </StyledContent>
  </Modal>
);

export default ReferAndEarn;
